//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            index: 0,
            loading: false,
            answers: [
                {
                    active: false,
                    gift: this.$store.getters.getGift('w4d5statistician'),
                    instruction: this.$lang.get('w4d5.gift.statistics', {br: '\n'}),
                    bubble: this.$lang.get('w4d5.gift.data', {br: '\n'}),
                    bubbleX: 550
                },
                {
                    active: false,
                    gift: this.$store.getters.getGift('w4d5sportsscientist'),
                    instruction: this.$lang.get('w4d5.gift.sport', {br: '\n'}),
                    bubble: this.$lang.get('w4d5.gift.training', {br: '\n'}),
                    bubbleX: 600
                },
                {
                    active: false,
                    gift: this.$store.getters.getGift('w4d5psychologist'),
                    instruction: this.$lang.get('w4d5.gift.psychology', {br: '\n'}),
                    bubble: this.$lang.get('w4d5.gift.willpower', {br: '\n'}),
                    bubbleX: 580
                },
                {
                    active: false,
                    gift: this.$store.getters.getGift('w4d5prothesistechnician'),
                    instruction: this.$lang.get('w4d5.gift.prostheses', {br: '\n'}),
                    bubble: this.$lang.get('w4d5.gift.help', {br: '\n'}),
                    bubbleX: 600
                }
            ]
        };
    },

    computed: {
        activeAnswer () {
            return this.answers.find(answer => answer.active);
        }
    },

    created () {
        if (this.$store.getters.hasUserFinishedWeek(this.$route.meta.week)) {
            this.$router.push({ name: 'next' });
        }
    },

    methods: {
        setAnswer (answer) {
            this.answers.forEach(answer => answer.active = false);
            answer.active = true;
        },
        store() {
            this.loading = true;

            axios.post('game/gift', {
                name: this.activeAnswer.gift.name,
                week: this.activeAnswer.gift.week
            }).then(response => {
                this.$store.commit('storeGameData', response.data.data);
                this.showNext = true;
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        }
    }
};
